/**
 * ...
 * TODO:
 * Purpose - Smoothly scroll to the section using the scrollTo() method.
 * Desktop and Mobile Both Smooth Scroll Functionality.
 * ...
 */
const customSelectors = {};
class customJS {
    constructor() {
        // Get the section element by its ID
        const link = document.querySelectorAll('[href="#company"]');
        const mobileMenu = document.querySelector('#mobile-menu')
        link.forEach(element=>{
            element.addEventListener('click',(event)=>{
                event.preventDefault();
                // Smoothly scroll to the section using the scrollTo() method
                document.querySelector("#mobile-menu-drawer").classList.remove('opened-drawer');
                siteOverlay.prototype.hideOverlay();
                let openDropdowns = Array.from(document.querySelectorAll('#mobile-menu-drawer .dropdown.open'));
                openDropdowns.forEach((ele)=>{
                    ele.classList.remove('open');
                    ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
                }
                );
                mobileMenu.setAttribute('aria-expanded', false);
                Utility.forceFocus(mobileMenu);
                if (document.querySelector('#company') != null) {
                    window.scrollTo({
                        top: document.querySelector('#company')?.offsetTop,
                        behavior: 'smooth'
                    });
                }else{
                    window.location.href="/#company"
                }
            })
        })
    }
}
typeof customJS !== 'undefined' && new customJS();
